import { render, staticRenderFns } from "./SalesLeadQuotaDetails.vue?vue&type=template&id=ab8e40d0&scoped=true&"
import script from "./SalesLeadQuotaDetails.vue?vue&type=script&lang=js&"
export * from "./SalesLeadQuotaDetails.vue?vue&type=script&lang=js&"
import style0 from "./SalesLeadQuotaDetails.vue?vue&type=style&index=0&id=ab8e40d0&prod&lang=scss&scoped=true&"
import style1 from "./SalesLeadQuotaDetails.vue?vue&type=style&index=1&id=ab8e40d0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab8e40d0",
  null
  
)

export default component.exports